
if(document.querySelector('body').classList.contains('template-suffix-subscription')){

}else{
  if(Object.keys(apConfig).length > 0 && document.querySelector('.cart-subtotal') != null){
    const cartTotal = document.querySelector('.cart-subtotal').dataset.amount;
    const apConfig = {
      priceSelector: '.cart-footer__total-price',
      locale: 'en_US',
      currency: 'USD',
      afterpayLogoColor: 'white',
      showUpperLimit: false,
      amount: cartTotal,
      minMaxThreshold: {
        min: 100,
        max: 100000,
      },
    };
    new presentAfterpay(apConfig).init();
  }
  if(apConfig != undefined){
    if(Object.keys(apConfig).length > 0 && document.querySelector('body').classList.contains('template-cart') && document.querySelector('.cart-subtotal') != null){
      const cartTotal = document.querySelector('.cart-subtotal').dataset.amount;
      const apConfig = {
        priceSelector: '.cart-policies',
        locale: 'en_US',
        currency: 'USD',
        afterpayLogoColor: 'white',
        showUpperLimit: false,
        amount: cartTotal,
        minMaxThreshold: {
          min: 100,
          max: 100000,
        },
      };
      new presentAfterpay(apConfig).init();
    }
    window.onload = function() {
      if(Object.keys(apConfig).length > 0 && document.querySelector('body').classList.contains('template-product')){
        const ap = new presentAfterpay(apConfig).init();
        // apConfig.priceSelector = '.main-mobile-price-selector';
        // new presentAfterpay(apConfig).init();
        // var price = document.querySelector('product-form.sticky-content-container .price');
        // var config = {childList: true, subtree: true };
      }  
    }
  }
}